module.exports = __webpack_public_path__ + "img/09.396950c8.jpg";